import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlashlightOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flashlight_on"}/>
}
